export default function SegmentedControl({
  label,
  selectedOption,
  setSelectedOption,
  options,
}: {
  label: string;
  selectedOption: string;
  setSelectedOption: (option: string) => void;
  options: string[];
}) {
  return (
    <div className="space-y-2 mb-2">
      <span className="text-sm mr-2">{label}</span>
      <div className="inline-flex h-9 w-full items-baseline justify-start rounded-lg bg-stone-100 p-1 sm:w-auto">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            className={`group inline-flex items-center justify-center whitespace-nowrap py-2 align-middle font-semibold transition-all duration-300 ease-in-out min-w-[32px] gap-1.5 text-xs h-7 w-full px-3 rounded-md sm:w-auto ${
              selectedOption === option
                ? "bg-white text-stone-950 drop-shadow"
                : "bg-transparent text-stone-600 hover:text-stone-950"
            }`}
            onClick={() => setSelectedOption(option)}
          >
            <div>{option}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
